import { StringHelpers } from 'e4shared';
import { e4Format, isPast, isToday } from 'helpers/dates';

export const Bullet = ({ style, icon, type, value, isDate, isDuration }) => {
    if (isDate) {
        if (isToday(value)) {
            value = 'Due today';
            icon = 'triangle-exclamation';
            style = 'due';
        } else if (isPast(value)) {
            value = 'Overdue';
            icon = 'circle-exclamation';
            style = 'overdue';
        } else {
            value = `Due ${e4Format(value)}`;
            icon = 'calendar';
            style = 'steel';
        }
    }

    if (isDuration) {
        icon = 'clock';
        style = 'desert';
        value = StringHelpers.displayMinutes(value);
    }

    switch (type) {
        case 'behavior':
            icon = 'user-gear';
            value = 'Behavior';
            break;
        case 'course':
            icon = 'arrow-up-right-from-square';
            value = 'Course';
            break;
        case 'objective':
            icon = 'square-check';
            value = 'Objective';
            break;
        case 'pathway':
            icon = 'rocket';
            value = 'Pathway';
            break;
        case 'review':
            icon = 'gauge';
            value = 'Review';
            break;
        default:
            break;
    }

    return (
        <div className={`prism-bullet no-wrap ${style}`}>
            <i className={`fa fa-${icon} mr10`} />
            {value}
        </div>
    );
};

export default Bullet;
